import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { ConfigService, TranslatePipe } from '@speedy/core';

@Component({
  selector: 'app-product-stock-options',
  templateUrl: './product-stock-options.component.html',
  styleUrls: ['./product-stock-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslatePipe],
})
export class ProductStockOptionsComponent implements OnInit {
  private readonly configService = inject(ConfigService);

  @Input() salableQty = 0;
  @Input() stockText: 'In stock' | 'Out of stock' = 'In stock';
  @Input() isInStock = false;

  stockThresholdQty: string | undefined;

  ngOnInit(): void {
    const configPath = 'cataloginventory/options/stock_threshold_qty';

    this.stockThresholdQty = this.configService.getConfig(configPath);
  }

  get isShowItemsLeft(): boolean {
    const isStockThresholdDefined = this.stockThresholdQty !== undefined;
    const isProductQtyWithinThreshold = this.salableQty <= +(this.stockThresholdQty ?? 0);

    return isStockThresholdDefined && isProductQtyWithinThreshold && this.isInStock;
  }
}
